import React from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { pluginBarraMinima } from "../utils/chartMinBar";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const cores = {
  azulEscuro: "#01054C",
  azulMedio:  "#034EA2",
  verde:      "#389807",
  amarelo:    "#F5C115",
  branco:     "#FFFFFF",
  texto:      "#01054C",
  textoData:  "#364153",
  textoFiltro: "#0A0A0A",
  borda:      "#D1D5DB",
};

const configCards = [
  { cor: "#01054C", textoCor: cores.branco },
  { cor: "#389807", textoCor: cores.branco },
  { cor: "#F5C115", textoCor: cores.branco },
  { cor: "#034EA2", textoCor: cores.branco },
];

const plugins = [pluginBarraMinima("campanhaBarraMinima", 20)];

const opcoes = {
  responsive: true,
  maintainAspectRatio: false,
  layout: { padding: { top: 40 } },
  plugins: {
    legend: {
      position: "bottom",
      align: "start",
      reverse: true,
      labels: {
        font: { size: 11 },
        color: cores.textoFiltro,
        padding: 16,
        usePointStyle: true,
        pointStyle: "rectRounded",
        pointStyleWidth: 14,
        boxHeight: 10,
      },
    },
    tooltip: {
      callbacks: {
        label: (ctx) => ` ${ctx.dataset.label}: ${ctx.raw}`,
      },
    },
    datalabels: {
      anchor: "center",
      align: "center",
      color: cores.branco,

      font: { size: 11, weight: "bold" },
      formatter: (v) => (v > 0 ? String(v) : ""),
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: { display: false },
      border: { display: true, color: cores.borda },
      ticks: { font: { size: 12, weight: "bold" }, color: cores.textoData },
    },
    y: {
      stacked: true,
      display: false,
      beginAtZero: true,
    },
  },
};

const CampanhaPassouGanhou = ({
  titulo = "CAMPANHA PASSOU GANHOU",
  statCards = [],
  labels = [],
  naoTransacionaram = [],
  bateramMeta = [],
  transacionouNaoBateu = [],
}) => {
  const dados = {
    labels,
    datasets: [
      {
        label: "Transacionou, mas não bateu a meta",
        data: transacionouNaoBateu,
        backgroundColor: cores.amarelo,
        barPercentage: 0.55,
        categoryPercentage: 0.5,
      },
      {
        label: "Bateram a Meta",
        data: bateramMeta,
        backgroundColor: cores.verde,
        barPercentage: 0.55,
        categoryPercentage: 0.5,
      },
      {
        label: "Não Transacionaram",
        data: naoTransacionaram,
        backgroundColor: cores.azulMedio,
        barPercentage: 0.55,
        categoryPercentage: 0.5,
      },
    ],
  };

  return (
    <div
      className="rounded-xl bg-white p-6"
      style={{ boxShadow: "0 1px 6px 0 rgba(0,0,0,0.10)" }}
    >
      <h2 className="mb-4 text-xl font-bold uppercase" style={{ color: cores.texto }}>
        {titulo}
      </h2>

      {statCards.length > 0 && (
        <div className="mb-6 grid grid-cols-2 gap-3 lg:grid-cols-4">
          {statCards.map((card, i) => {
            const cfg = configCards[i] ?? configCards[0];
            return (
              <div
                key={i}
                className="flex flex-col items-center justify-center gap-1 rounded-lg px-4 py-3 text-center"
                style={{ backgroundColor: cfg.cor }}
              >
                <span className="text-xs font-medium" style={{ color: cfg.textoCor, opacity: 0.85 }}>
                  {card.label}
                </span>
                <span className="text-xl font-bold" style={{ color: cfg.textoCor }}>
                  {card.value}
                </span>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ height: 300 }}>
        <Bar data={dados} options={opcoes} plugins={plugins} />
      </div>
    </div>
  );
};

export default CampanhaPassouGanhou;
